export default __webpack_public_path__ + "static/media/b_wdt_c_1.007facb3.mp3";